import Home from "../../../Components/Client/Home";

const HomePage = () => {
  return <Home />;
};

export default HomePage;
